import * as React from 'react';
import { COLOR_A, COLOR_B } from './CONSTANTS';

const Selector = ({ label, changeValue, value }) => {
	return (
		<div
			style={{
				width: '100%',
				height: '100%',
				display: 'flex',
				flexDirection: 'row',
				justifyContent: 'space-evenly',
				alignItems: 'center',
			}}
		>
			<div
				onClick={() => changeValue(-1)}
				style={{
					borderStyle: 'solid',
					borderWidth: '1rem 2rem 1rem 0',
					borderColor: `transparent ${COLOR_B} transparent transparent`,
				}}
			/>
			<div style={{ color: COLOR_B, padding: 'auto' }}>{label + ' : ' + value}</div>
			<div
				onClick={() => changeValue(1)}
				style={{
					borderStyle: 'solid',
					borderWidth: '1rem 0rem 1rem 2rem',
					borderColor: ` transparent transparent transparent  ${COLOR_B}`,
				}}
			/>
		</div>
	);
};

export default Selector;
